import React, { useEffect, useMemo, useRef } from 'react';
import { GridWrapper } from '@yme/atoms/grid';
import { useIsOnScreen, useMouseDrag, useWindowSize } from '@yme/common/hooks';
import { CHECKOUT_PAGE_ORDER } from '@yme/components/CheckoutForm/constants';
import { Step } from './Step';
import { PAYMENT_STEPS_NAVIGATION_TEST_ID, PAYMENT_STEPS_WRAPPER_TEST_ID } from './constants';
import { getStepConfig, setStepsTitles } from './helpers';
import { NavStyled, StepsListStyled, StepsStyled, StepsWrapperStyled } from './styled';
const SCROLL_OFFSET = 100;
const STEP_ID_PREFIX = 'STEP_ID';
const INTERSECTION_THRESHOLD = 0.99;
const stepsWidthArray = [];
export function StepsSection({ isRightToLeft, children, pageNumber, labels }) {
    const { isInfiniteDesktopView } = useWindowSize();
    const navRef = useRef(null);
    const configure = useMemo(() => getStepConfig(setStepsTitles(labels), pageNumber), [labels, pageNumber]);
    const { mouseEventHandlers } = useMouseDrag(navRef);
    const { isOnScreen: isFirstOnScreen, ref: firstRef } = useIsOnScreen(INTERSECTION_THRESHOLD);
    const { isOnScreen: isLastOnScreen, ref: lastRef } = useIsOnScreen(INTERSECTION_THRESHOLD);
    const isSuccessPage = pageNumber === CHECKOUT_PAGE_ORDER.successPage;
    const getRef = (index, length) => {
        if (index === 0) {
            return firstRef;
        }
        if (index === length - 1) {
            return lastRef;
        }
        return null;
    };
    useEffect(() => {
        if (!isInfiniteDesktopView && navRef?.current) {
            const currentElement = document.querySelector(`#${STEP_ID_PREFIX}_${pageNumber}`);
            const currentElementScrollLeft = currentElement?.offsetLeft;
            navRef.current.scrollLeft = currentElementScrollLeft - SCROLL_OFFSET;
        }
    }, [isInfiniteDesktopView, labels, pageNumber]);
    return (React.createElement(React.Fragment, null,
        !isSuccessPage && (React.createElement(StepsWrapperStyled, { "data-testid": PAYMENT_STEPS_WRAPPER_TEST_ID },
            React.createElement(GridWrapper, { containerProps: {
                    isRightToLeft,
                } },
                React.createElement(StepsStyled, { isRightToLeft: isRightToLeft },
                    React.createElement(NavStyled, { ref: navRef, ...mouseEventHandlers, "data-testid": PAYMENT_STEPS_NAVIGATION_TEST_ID },
                        React.createElement(StepsListStyled, { isFirstOnScreen: isFirstOnScreen, isLastOnScreen: isLastOnScreen, isRightToLeft: isRightToLeft }, configure?.map((item, index) => {
                            const ref = getRef(index, configure.length);
                            return (React.createElement(Step, { id: `${STEP_ID_PREFIX}_${item.number}`, key: index, isRightToLeft: isRightToLeft, stepConditions: item, element: ref, stepsWidthArray: stepsWidthArray }));
                        }))))))),
        children));
}
